module.exports = __webpack_public_path__ + "cancellara-dist/img/health-italia.03723299.png";